import PDFDocument from "pdfkit/js/pdfkit.standalone.js";
import { PDFGenerator } from './pdf-generator';

/**
 * This file defines extension methods for the PDFDocument class
 * from pdfKit.
 * 
 * The purpose is to lighten the PDFGenerator class and to make custom
 * methods accessible with the same syntax as the original one 
 * (ex : boldText() ~ text())
 */

PDFDocument.prototype.boldText = function (textValue, options?): void {
    this.save()
    this
        .font(PDFGenerator.BOLD_FONT)
        .fontSize(PDFGenerator.BODY_TEXT_FONT_SIZE)
        .text(textValue, options)
    this.restore()
}

PDFDocument.prototype.sectionTitle = function (sectionTitle: string, underlineOffset: number = 50) {
    this.save()
    this.regularText("", { continued: false })
    this.font(PDFGenerator.BOLD_FONT)
    this.moveDown();
    this.fontSize(PDFGenerator.SECTION_FONT_SIZE)
        .fill("black")
        .text(sectionTitle, {
            align: 'left',
            weight: 'bold'
        });
    this.save()
        .moveTo(this.x, this.y)
        .lineTo(this.page.width - PDFGenerator.DOCUMENT_MARGIN, this.y)
        .stroke();
    this.restore()
}

PDFDocument.prototype.softSeparationLine = function () {
    const lineOffset = 75;
    this.save()
        .moveTo(this.x + lineOffset, this.y)
        .lineTo(this.page.width - lineOffset - PDFGenerator.DOCUMENT_MARGIN, this.y)
        .stroke('darkgrey');
    this.restore()
}

PDFDocument.prototype.regularText = function (text: string, options?: any) {
    this.save()
    this
        .fill("black")
        .font(PDFGenerator.REGULAR_FONT)
        .fontSize(PDFGenerator.BODY_TEXT_FONT_SIZE)
        .text(text, options)
    this.restore()
}

PDFDocument.prototype.dataWithBoldLabel = function (label: string, value: string, options?: any) {
    if (value || (options && options.displayIfNoValue)) {
        this.save()
        this.boldText(label + " ", { ...options, continued: true })
        this.regularText(value || "...", { paragraphGap: 8 })
        this.restore()
    }
}

/**
 * Resets the continue property of a paragraph
 */
PDFDocument.prototype.breakContinue = function () {
    this.regularText("", { continue: false })
    this.moveUp()
}